import React from 'react'
import styled from 'react-emotion'
import { colors } from '../../styles'

const DisplayName = styled('div')`
  font-size: 1.8rem;
  font-weight: bold;
  margin: 5px 0;
  line-height: 1.2;
  a {
    text-decoration: none;
    color: ${colors.tui_dark_blue};
  }
  @media (max-width: 992px) {
    font-size: 2.2rem;
    margin-top: 0px;
  }
`

export default ({ classification, name, siteUrl, queryString }) => (
  <DisplayName>
    {siteUrl ? (
      <a href={`${siteUrl}${queryString || ''}`} className="no-hover" target="_blank" rel="noopener noreferrer">
        {name} <span className="rating">{classification && classification.name}</span>
      </a>
    ) : (
      <span>
        {name} <span className="rating">{classification && classification.name}</span>
      </span>
    )}
  </DisplayName>
)
